import * as Api from '@utils/Api';
import { call, put } from 'redux-saga/effects';
import { types as ratingsTypes } from '@reducers/ratings';
import {
  confirmedRatingsKey,
  getAnonymousAction,
  removeAnonymousAction,
  setAnonymousAction,
} from '../utils/anonymousActionsStore';

export function* confirmRating(action) {
  const { ratingUuid, helpful, ratingType } = action;
  const response = yield call(
    Api.post,
    `/reviews/confirm/${ratingUuid}/${helpful}/${ratingType}`
  );

  if (!response.success) {
    yield put({
      type: ratingsTypes.RATING_CONFIRM_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });
  } else {
    const confirmedRatingIds = response.data
      ? response.data.ratings_confirmed
      : null;
    // Right now only "confirming" rating when unauthenticated
    // So it is an anonymous action
    setAnonymousAction(confirmedRatingsKey, confirmedRatingIds);
    yield put({
      type: ratingsTypes.RATING_CONFIRM_SUCCESS,
    });
  }
}

export function* postRating(action) {
  const { ratingUuid, helpful, ratingType, stars } = action;

  if (!ratingUuid || !stars) {
    throw new Error('Missing required parameters for posting star rating');
  }

  const response = yield call(
    Api.post,
    `/reviews/ratings/${ratingUuid}/${helpful}/${ratingType}`,
    { rating: stars }
  );

  if (!response.success) {
    yield put({
      type: ratingsTypes.RATING_STARS_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });
  } else {
    yield put({
      type: ratingsTypes.RATING_STARS_SUCCESS,
    });
  }
}

export function* postFeedback(action) {
  const {
    ratingUuid,
    helpful,
    ratingType,
    reasons,
    likedReviewers,
    dislikedReviewers,
    comments,
  } = action;

  if (!ratingUuid) {
    throw new Error('Missing required parameters for posting star rating');
  }

  const feedback = {
    reasons,
    liked_reviewers: likedReviewers,
    disliked_reviewers: dislikedReviewers,
    comments,
  };

  const response = yield call(
    Api.post,
    `/reviews/feedback/${ratingUuid}/${helpful}/${ratingType}`,
    feedback
  );

  if (!response.success) {
    yield put({
      type: ratingsTypes.RATING_FEEDBACK_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });
  } else {
    yield put({
      type: ratingsTypes.RATING_FEEDBACK_SUCCESS,
    });
  }
}

export function* tieUserToUnauthedRatings() {
  // Because this is called by fetchAccount, we want to make sure it doesnt
  // run this again while it is already running.
  if (localStorage.getItem('isTying')) {
    return;
  }

  // If not already running, set variable to show it is currently running.
  localStorage.setItem('isTying', true);
  const confirmedRatingUuids = getAnonymousAction(confirmedRatingsKey);
  if (!confirmedRatingUuids || !confirmedRatingUuids.length) {
    yield put({
      type: ratingsTypes.RATING_TIE_RATINGS_SUCCESS,
    });
    return;
  }

  const response = yield call(Api.post, `/reviews/tie_confirmed_ratings`, {
    rating_uuids: confirmedRatingUuids,
  });

  if (!response.success) {
    localStorage.removeItem('isTying');
    yield put({
      type: ratingsTypes.RATING_TIE_RATINGS_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });
  } else {
    localStorage.removeItem('isTying');
    removeAnonymousAction(confirmedRatingsKey);
    yield put({
      type: ratingsTypes.RATING_TIE_RATINGS_SUCCESS,
    });
  }
}
